import React from 'react';
import { CircleBadge, rem, SettingsItem, SettingsItemRightContent, } from 'design-system';
import { CIRCLE_SIZE, CIRCLE_BORDER_SIZE } from 'design-system/LogoBankAccount';
import { StyleSheet, View } from 'react-native';
import EditTransactionSelect from 'features/transactions/components/multiple/EditTransactionSelect';
import Amount from 'design-system/Amount';
import { IconCheckMark } from 'design-system/icons';
import useColors from 'hooks/useColors';
import { Avatar } from 'design-system/avatar';
export const GroupUserAvatar = ({ groupUser, selected }) => {
    const colors = useColors();
    return (<View style={styles.avatar}>
      <Avatar name={groupUser.firstName || groupUser.handle || ''} lastName={groupUser.lastName || ''} color={colors.background.brandLight} fontColor={colors.text.textOnBrand} imageUrl={groupUser?.profilePicUrl} size={rem(CIRCLE_SIZE)} borderWidth={CIRCLE_BORDER_SIZE} medium/>
      {selected ? (<CircleBadge backgroundColor={colors.elements.brand} borderColor={colors.borders.iconStroke} offset={4}>
          <IconCheckMark />
        </CircleBadge>) : null}
    </View>);
};
export const GroupExpenseCRow = ({ groupUser, onPress, balance, selected, currency, convertedBalance, convertedCurrency, showMinus = true, ...props }) => (<SettingsItem renderIcon={() => (<GroupUserAvatar groupUser={groupUser} selected={selected}/>)} onPress={() => onPress(groupUser)} title={`${groupUser.firstName} ${groupUser.lastName}`} description={groupUser.handle ? `@${groupUser.handle}` : undefined} key={groupUser.id} {...props}>
    {balance !== undefined ? (<SettingsItemRightContent>
        {balance > 0 ? (<Amount Blue Numbers-16 value={{ value: balance, currency }} showSign/>) : (<Amount OffBlack Numbers-16 value={{ value: showMinus ? balance : Math.abs(balance), currency }}/>)}
        {convertedBalance !== undefined && !!convertedCurrency && (<Amount Secondary NumbersThin-16 value={{ value: convertedBalance, currency: convertedCurrency }} showSign/>)}
      </SettingsItemRightContent>) : null}
  </SettingsItem>);
export const GroupExpenseCRowSelectable = ({ selected = false, groupUser, isMultipleSelect = true, disabled, ...props }) => (<GroupExpenseCRow renderIcon={() => (<View style={styles.selectableAvatarContainer}>
          {!disabled && (<EditTransactionSelect selected={selected} isMultipleSelect={isMultipleSelect}/>)}
          <GroupUserAvatar groupUser={groupUser}/>
        </View>)} groupUser={groupUser} {...props}/>);
const styles = StyleSheet.create({
    avatar: {
        marginRight: rem(16),
    },
    selectableAvatarContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
});
